import { Capacitor } from "@capacitor/core";

/** Diagnostics only. Missing App plugin on older bundles never blocks studying. */
export async function studyClientInfo(): Promise<{ platform: "web" | "ios" | "android"; appVersion?: string; protocol: 1 }> {
  const name = Capacitor.getPlatform();
  const platform = name === "ios" || name === "android" ? name : "web";
  if (platform === "web") return { platform, protocol: 1 };
  try {
    const { App } = await import("@capacitor/app");
    const info = await App.getInfo();
    return { platform, appVersion: info.version.slice(0, 40), protocol: 1 };
  } catch { return { platform, protocol: 1 }; }
}